import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { Circles } from "react-loader-spinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import DOMPurify from 'dompurify';

const BASE_URL = "https://api.shabdtoday.com/";
const image_resize = "https://api.shabdtoday.com/api/home/resize";
const clicklocal = "http://localhost:44351/api/home/update-viewcount"
const clickonline = "https://api.shabdtoday.com/api/home/update-viewcount"
const truncateText = (text, maxLength) => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength);
  }
  return text;
};

const stripHtmlTags = (html, maxLength) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  const strippedText = tempDiv.textContent || tempDiv.innerText || "";
  return truncateText(strippedText, maxLength);
};

const renderHtmlContent = (html) => {
  const sanitizedHtml = DOMPurify.sanitize(html);
  return { __html: sanitizedHtml };
};


function BollywoodNews2() {
  const [postData, setPostData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://api.shabdtoday.com/api/home/khelKhabars2?page=1&limit=5"
        );
        setPostData(response.data);
        setLoading(false);
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleNewsClick2 = async (slug, mainKhabarId) => {
    try {
      const response = await axios.post(`${clickonline}`, {
        mainKhabarId: mainKhabarId
      });

      if (response.status === 200) {
        // console.log("View count updated successfully", response.data);
        window.location.href = `/Khel-News/${slug}`;
      } else {
        console.error("Failed to update view count", response.data);
      }
    } catch (error) {
      console.error("Error updating view count:", error.response ? error.response.data : error.message);
    }
  };
  const formatDateInHindi = (dateString) => {
    const date = new Date(dateString);
    const monthsInHindi = [
      "जनवरी",
      "फरवरी",
      "मार्च",
      "अप्रैल",
      "मई",
      "जून",
      "जुलाई",
      "अगस्त",
      "सितंबर",
      "अक्टूबर",
      "नवंबर",
      "दिसंबर",
    ];
    const seconds = date.getSeconds();
    const minute = date.getMinutes();
    var hour = date.getHours();
    const day = date.getDate();
    const month = monthsInHindi[date.getMonth()];
    const year = date.getFullYear();
    const amPm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;
    return `${day} ${month} ${year} \n ${hour}:${minute < 10 ? "0" + minute : minute} ${amPm}`;
  };
  const getTimeAgoInHindi = (dateString) => {
    const now = new Date();
    const past = new Date(dateString);
    const diffInSeconds = Math.floor((now - past) / 1000);

    if (diffInSeconds < 60) {
      return `${diffInSeconds} सेकंड पहले`;
    }

    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) {
      return `${diffInMinutes} मिनट पहले`;
    }

    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) {
      return `${diffInHours} घंटे पहले`;
    }

    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 30) {
      return `${diffInDays} दिन पहले`;
    }

    const diffInMonths = Math.floor(diffInDays / 30);
    if (diffInMonths < 12) {
      return `${diffInMonths} महीने पहले`;
    }

    const diffInYears = Math.floor(diffInMonths / 12);
    return `${diffInYears} साल पहले`;
  };

  const generateShareLinks = (mainKhabarId, newsTag) => {
    const encodednewsTag = encodeURIComponent(newsTag);
    const url = `${window.location.origin}/News-Details/${mainKhabarId}`;
    return {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${encodednewsTag}`,
      whatsapp: `https://api.whatsapp.com/send?text=${encodednewsTag} ${url}`,
      twitter: `https://twitter.com/intent/tweet?text=${encodednewsTag}&url=${url}`,
      instagram: `https://www.instagram.com/`
    };
  };
  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        {/* <Circles
          height="30"
          width="30"
          color="#f7265c"
          ariaLabel="circles-loading"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
        /> */}
      </div>
    );
  }

  if (error) {
    return <div>Error: {error}</div>;
  }
  return (
    <div>

      <div
        className="ak-block ak-block-3  ak-block-column ak-block-module-thumb-round ak-block-inner-boxed ak-block-width-1 clearfix"
        id="block_65f7f61f36732_9"
      >
        <div className="ak-block-header ak-block-header-style-5 no-tabs">
          <div
            className="main-wdgt container"
            id="widget-rs-4937"
            data-vars-widget-type="home"
            data-vars-widget-name="astrology"
            data-vars-orderid={10}
          >
            <div>
              <Link to="/khel-News" title="धर्म" >
                <span className="head" style={{ color: "crimson" }}>खेल</span>
              </Link>
            </div>

          </div>
        </div>
        <div className="ak-block-inner clearfix">
          <div className="ak-block-posts clearfix">
            {postData.khelKhabars2.slice(0, 5).map((post) => {
              const shareLinks = generateShareLinks(post.mainKhabarId, post.newsTag);
              return (
                <article key={post.mainKhabarId} className="bordergap ak-module ak-module-1-small ak-column-module ak-module-meta-hide clearfix post-225 post type-post status-publish format-standard has-post-thumbnail  category-business category-entertainment category-tech-science category-work-life tag-breaking tag-election tag-politics tag-technology tag-world-news">
                  <div className="ak-module-inner clearfix">
                    <div className="ak-module-featured">
                      <div className="ak-featured-cover">
                        <Link
                          to={`/Khel-News/${post.mainKhabarId}`}
                          className="ak-featured-link"
                          rel="bookmark"
                          title={stripHtmlTags(post.newsTag, 50)}
                        >
                          <div className="ak-featured-thumb  size-715">
                            <img
                              width={120}
                              height={86}
                              src={`${BASE_URL}${post.newsImage}`}
                              className="wp-post-image"
                              alt={post.slug}
                              data-src={`${BASE_URL}${post.newsImage}`}
                              data-sizes="auto"
                              data-srcset={`${BASE_URL}${post.newsImage}`}
                              data-expand={700}
                            />
                          </div>
                          <span style={{ color: "" }}>
                            {getTimeAgoInHindi(post.date)}
                          </span>
                        </Link>
                      </div>
                    </div>
                    <div className="ak-module-details">
                      <h2 className="ak-module-title" style={{ textAlign: "justify" }}>
                        <Link
                          to="#"
                          onClick={(e) => {
                            e.preventDefault();
                            handleNewsClick2(post.slug, post.mainKhabarId)
                          }}
                          rel="bookmark"
                          title={stripHtmlTags(post.newsTag)}

                        >
                          <span style={{ fontSize: "15px", lineHeight: "20px", fontWeight: "600", textAlign: "justify" }} dangerouslySetInnerHTML={renderHtmlContent(post.newsTag)} />
                        </Link>
                      </h2>
                      <div className="ak-module-meta">
                        <div className="ak-module-time">
                          <Link
                            to="#"
                            onClick={(e) => {
                              e.preventDefault();
                              handleNewsClick2(post.slug, post.mainKhabarId)
                            }}
                            className="ak-module-meta-published"
                          >
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </article>
              );
            })}

          </div>
        </div>
      </div>

    </div >
  )
}

export default BollywoodNews2
